import Blank from './blank'
export default Blank